<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/hit-products/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :hitProducts="hitProducts" @update="fetchHitProducts" />
      <b-row v-if="numberOfPages > 0">
        <b-colxx xxs="12">
          <b-pagination-nav
            size="sm"
            :number-of-pages="numberOfPages"
            :link-gen="linkGen"
            v-model="page"
            :per-page="perPage"
            align="center"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right" />
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left" />
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start" />
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end" />
            </template>
          </b-pagination-nav>
        </b-colxx>
      </b-row>
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/HitProducts/DataList.vue'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: { DataListItem },
  data() {
    return {
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/hit_product'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    hitProducts() {
      const pages = this.$store.getters['hitProducts/hitProducts']
      return handleArrayDataInternalization(pages, ['name'], this.$i18n.locale)
    },
    isLoading() {
      return this.$store.getters['hitProducts/isLoading']
    }
  },
  mounted() {
    this.fetchHitProducts()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchHitProducts() {
      this.$store.dispatch('hitProducts/fetchHitProducts', { vm: this })
    }
  },
  watch: {
    apiUrl() {
      this.fetchHitProducts()
    }
  }
}
</script>
